import apiClient from "./apiClient";

export const uploadFile = (id, data, onUploadProgress) =>
  apiClient.post(`/uploads/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onUploadProgress(percentCompleted);
      }
    },
  });

export const uploadLogo = (data, onUploadProgress) =>
    apiClient.post(`/logo-uploads`, data, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
        if (onUploadProgress) {
            const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
            );
            onUploadProgress(percentCompleted);
        }
        },
});

export const uploadSignature = (data, onUploadProgress) =>
    apiClient.post(`/signature-uploads`, data, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
        if (onUploadProgress) {
            const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
            );
            onUploadProgress(percentCompleted);
        }
        },
});

export const renameFile = (id, data) => apiClient.put(`/uploads/${id}/filename`, data);

export const getFilesByPetId = (id, page = 1, limit = 10, tags="", mode="", sort="", order="") => apiClient
    .get(`/uploads/${id}`, { params: { page, limit, tags, mode, sort, order } })
    .then(res => res);

export const getOfficeFiles = ({page = 1, limit = 10, tags="", mode="", sort="", order="", search=""}) => apiClient
    .get(`/uploads/office/files`, { params: { page, limit, tags, mode, sort, order, search } })
    .then(res => res);

export const downloadFile = (id) => apiClient.get(`/uploads/download/${id}`, {responseType: "blob"});
export const downloadThumbnail = (id) => apiClient.get(`/uploads/download/${id}/thumbnail`, {responseType: "blob"});

export const searchFilesByPetId = (id, page = 1, limit = 10, filename="", tags="", mode="") => apiClient
    .get(`/uploads/${id}/search`, { params: { page, limit, filename, tags, mode } })
    .then(res => res);

export const searchFilesGlobal = (page = 1, limit = 10, filename="", tags="", mode="") => apiClient
    .get(`/uploads/search`, { params: { page, limit, filename, tags, mode } })
    .then(res => res);

export const deleteFile = (id) => apiClient.delete(`/uploads/${id}`);